import html from "./WaitStep.html"
import "./WaitStep.css"

var module = angular.module("ResearchKitApplicationModule");

module.directive("waitStep", [
	function () {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			}
		};
	}]
);

module.factory("WaitStepManager", ["StepManager", function (StepManager) {
	function WaitStepManager(step, surveyManager) {
		StepManager.call(this, step, surveyManager);
	}
	WaitStepManager.prototype = Object.create(StepManager.prototype);

	WaitStepManager.prototype.isLastInstructionStep = function () {
		if (this.surveyManager.editMode) {
			return false;
		}

		for (var i = 0; i < this.surveyManager.managedStepIdentifiers.length; i++) {
			var identifier = this.surveyManager.managedStepIdentifiers[i];
			var step = _.findWhere(this.surveyManager.template.steps, { identifier: identifier });
			if (step.type !== 'WaitStep') {
				return false;
			}
		}

		var nextStep = this.surveyManager.nextStep();
		if (nextStep && nextStep.type !== 'WaitStep') {
			return true;
		}
		return false;
	}

	WaitStepManager.prototype.canGoBack = function () {
		return false;
	}

	WaitStepManager.prototype.showSaveAndClose = function () {
		return false;
	}

	return WaitStepManager;
}]);